export const RELEASE_CONTRIBUTOR_ROLES = [
    {
        code: 'PRIMARY',
        name: 'releases.contributors.roles.primary'
    }, {
        code: 'FEATURED',
        name: 'releases.contributors.roles.features'
    }, {
        code: 'PRODUCER',
        name: 'releases.contributors.roles.producer'
    }, {
        code: 'REMIXER',
        name: 'releases.contributors.roles.remixer'
    }, {
        code: 'COMPOSER',
        name: 'releases.contributors.roles.composer'
    }, {
        code: 'MIXER',
        name: 'releases.contributors.roles.mixer'
    }, {
        code: 'MASTERING_ENGINEER',
        name: 'releases.contributors.roles.mastering-engineer'
    }, {
        code: 'LYRICIST',
        name: 'releases.contributors.roles.lyricist'
    }
].sort((a, b) => a.code > b.code ? 1 : -1)
